import React, { useState, useEffect } from "react";
import classNames from "classnames/bind";
import { toast } from "react-toastify";

// styles
import styles from "./BlogSlider.module.scss";

// components
import BlogItem from "src/components/Blog/BlogItem/BlogItem";
import { Heading, Slider } from "src/components";

// mockup
import mockup from "src/utils/data";

// api
import { getBlogList } from "src/components/Blog/api";

const cx = classNames.bind(styles);

const CarouselNew = () => {
  const [blogList, setBlogList] = useState(mockup.empty_3);

  useEffect(() => {
    getBlogList()
      .then((res) => {
        console.log("blog", res);
        if (res.data.Status) {
          setBlogList(res.data.Results.filter((item) => item.BlogId !== 3));
        } else {
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  }, []);

  return (
    <div className={cx("carousel--new", "blog-slider-root")}>
      <h1 className={cx("heading")}>
        {`How to Find Small Local live music\nEvents in Your Area.`}
      </h1>
      <Slider
        list={blogList}
        Item={BlogItem}
        wrapperClass={cx("custom-slider-btn-wrapper")}
        space={16}
        perView={1}
        center={false}
        pagination={{ clickable: true }}
        breakpoints={{
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
          // 1300: {
          //   slidesPerView: 3,
          //   spaceBetween: 52,
          // },
        }}
      />
    </div>
  );
};

export default CarouselNew;
